import { LucideIcon } from 'lucide-react'

type MetricCardProps = {
    title: string
    value: string | number
    description?: string
    color?: string
}

export const MetricCard = ({
    title,
    value,
    description,
    color,
}: MetricCardProps) => (
    <div className="rounded-lg border bg-card p-4 sm:p-5">
        <div className="flex items-start justify-between">
            <div className="min-w-0 flex-1">
                <p className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
                    {title}
                </p>
                <p className="text-lg sm:text-2xl font-semibold text-foreground mt-1">
                    {value}
                </p>
                {description && (
                    <p className="text-xs text-muted-foreground mt-1">
                        {description}
                    </p>
                )}
            </div>
        </div>
    </div>
)
